import { Injectable } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {
  private BASE_URL: string = environment.API_URL;
  // private BASE_URL: string = 'http://52.66.143.47:8000/';
    //private BASE_URL: string = "http://3.108.44.158:8000/uat/";
    //private BASE_URL: string = "http://13.127.121.254:8000/qa/";
    private errorData: any = {}; 
    adminLoginData:any = JSON.parse(localStorage.getItem('adminLoginPass') || '[]');
    data:any= "";
    contentAuth="";
    username: string = this.adminLoginData.email; password: string = this.adminLoginData.pass;
    //username:string="shubham.j@unikove.com";password:string="shubh@123";
    authorizationData :any= 'Basic ' + btoa(this.username + ':' + this.password);
    
    httpOptions = {
      headers: new HttpHeaders({ 'Authorization': this.authorizationData, 'Content-Type': 'application/json',
    })
    };
    httpOptions1 = {
      headers: new HttpHeaders({ 'Authorization': this.authorizationData})
                };
    constructor(private http:HttpClient,private router:Router) { }
    
  /**********Create Module Assessemnt Detail************/
   assessmentDetail(id:number): Observable<any>{
    //return this.http.post(this.BASE_URL+'assessment/details',{ "assessment_id" : id},this.httpOptions);
    return this.http.post(this.BASE_URL+'assessment/details-admin',{ "assessment_id" : id},this.httpOptions);
   }
   /**********module Assessemnt list************/
   assessmentListing(): Observable<any>{
    return this.http.post(this.BASE_URL+'assessment/list',{},this.httpOptions);
   }
   /**********module Assessemnt list************/
   dltassessment(assessment_id:any, content_capsule_id:any, ): Observable<any>{
    return this.http.post(this.BASE_URL+'delete/assessment',{ "assessment_id" : assessment_id, "content_capsule_id": content_capsule_id},this.httpOptions);
   }

  /***********Create Module Assessment******** */
  createassessment(addAssData:any,page:any): Observable<any> {
    if(page =='create'){
      return this.http.post<any>(this.BASE_URL+'create/assessment',addAssData,this.httpOptions)
        .pipe(map(data => {
          if (data) {
            return data;
          }
        }),
        catchError(this.handleError)
      );
    }else{
      return this.http.post<any>(this.BASE_URL+'edit/assessment',addAssData,this.httpOptions)
        .pipe(map(data => {
          if (data) {
            return data;
          }
        }),
        catchError(this.handleError)
      );
    }
      // return this.http.post<any>(this.BASE_URL+'edit/assessment',addAssData,this.httpOptions)
      //   .pipe(map(data => {
      //     if (data) {
      //       return data;
      //     }
      //   }),
      //   catchError(this.handleError)
      // );
    }
    private handleError(error: HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
    
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
      } else {
    
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong.
        console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
      }
    
      // return an observable with a user-facing error message
      this.errorData = {
        errorTitle: 'Oops! Request for document failed',
        errorDesc: 'Something bad happened. Please try again later.'
      };
      return throwError(this.errorData);
    }
    assessmentCreate(addAssData:any,page:any): Observable<any> {
      if(page =='create'){
        return this.http.post<any>(this.BASE_URL+'assessment/create',addAssData,this.httpOptions)
          .pipe(map(data => {
            if (data) {
              return data;
            }
          }),
          catchError(this.handleError)
        );
      }else{
        return this.http.post<any>(this.BASE_URL+'edit/assessment',addAssData,this.httpOptions)
          .pipe(map(data => {
            if (data) {
              return data;
            }
          }),
          catchError(this.handleError)
        );
      }
        // return this.http.post<any>(this.BASE_URL+'edit/assessment',addAssData,this.httpOptions)
        //   .pipe(map(data => {
        //     if (data) {
        //       return data;
        //     }
        //   }),
        //   catchError(this.handleError)
        // );
      }
  }
  